module.exports = __webpack_public_path__ + "static/media/RA-AP0005B_03.3d08797b.png";